import gql from 'graphql-tag';

/**
 * Paginated channel list for the bulk team permission management landing page.
 *
 * Uses the same admin-only `bulkModuleChannels` resolver as the bulk module
 * tooling, filtered/sorted via the extended `ChannelSearch` inputs (group
 * role and permission filters). Also reused directly for the Parent Channel
 * name filter dropdown — its `name` search + pagination already cover that
 * need without a dedicated name-options query.
 */
export const bulkTeamManagementChannelsQuery = gql`
  query BulkTeamManagementChannels(
    $pagination: PaginationInput!
    $search: ChannelSearch!
  ) {
    bulkModuleChannels(pagination: $pagination, search: $search) {
      pageInfo {
        start
        total
        perPage
      }
      items {
        _id
        name
        type
        parent {
          _id
          name
        }
      }
    }
  }
`;

export const distinctGroupRoleNamesQuery = gql`
  query DistinctGroupRoleNames($name: String, $pagination: PaginationInput!) {
    distinctGroupRoleNames(name: $name, pagination: $pagination) {
      items {
        name
        groupRoleIds
      }
    }
  }
`;
